'use client';

import { Component, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: any) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div data-component-id="src/components/ErrorBoundary.tsx:36:8" data-component-path="src/components/ErrorBoundary.tsx" data-component-line="36" data-component-end-line="49" data-component-file="ErrorBoundary.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22min-h-screen%20flex%20items-center%20justify-center%20px-4%22%7D" className="min-h-screen flex items-center justify-center px-4" style={{ background: '#0A0A0F' }}>
          <div data-component-id="src/components/ErrorBoundary.tsx:37:10" data-component-path="src/components/ErrorBoundary.tsx" data-component-line="37" data-component-end-line="48" data-component-file="ErrorBoundary.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%22%7D" className="text-center">
            <div data-component-id="src/components/ErrorBoundary.tsx:38:12" data-component-path="src/components/ErrorBoundary.tsx" data-component-line="38" data-component-end-line="38" data-component-file="ErrorBoundary.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-6xl%20mb-4%22%2C%22textContent%22%3A%22%E2%9A%A0%EF%B8%8F%22%7D" className="text-6xl mb-4">⚠️</div>
            <h1 data-component-id="src/components/ErrorBoundary.tsx:39:12" data-component-path="src/components/ErrorBoundary.tsx" data-component-line="39" data-component-end-line="39" data-component-file="ErrorBoundary.tsx" data-component-name="h1" data-component-content="%7B%22elementName%22%3A%22h1%22%2C%22className%22%3A%22text-2xl%20font-bold%20text-white%20mb-2%22%2C%22textContent%22%3A%22Something%20went%20wrong%22%7D" className="text-2xl font-bold text-white mb-2">Something went wrong</h1>
            <p data-component-id="src/components/ErrorBoundary.tsx:40:12" data-component-path="src/components/ErrorBoundary.tsx" data-component-line="40" data-component-end-line="40" data-component-file="ErrorBoundary.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-white%2F60%20mb-6%22%2C%22textContent%22%3A%22We%20apologize%20for%20the%20inconvenience%22%7D" className="text-white/60 mb-6">We apologize for the inconvenience</p>
            <button data-component-id="src/components/ErrorBoundary.tsx:41:12" data-component-path="src/components/ErrorBoundary.tsx" data-component-line="41" data-component-end-line="47" data-component-file="ErrorBoundary.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22px-6%20py-3%20rounded-xl%20font-bold%20text-white%22%2C%22textContent%22%3A%22Reload%20Page%22%7D"
              onClick={() => window.location.reload()}
              className="px-6 py-3 rounded-xl font-bold text-white"
              style={{ background: 'linear-gradient(135deg, #F59E0B, #F97316)' }}
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
